<template>
  <div class="boothHeaderMeta">
    <div v-if="props.typeDisplayName">
      {{ props.typeDisplayName }}
    </div>
    <div v-if="props.boothNumber" class="ml-6.25">
      {{ props.boothNumber }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  boothNumber?: string | null
  typeDisplayName?: string | null
}>()
</script>

<style scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.boothHeaderMeta {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  @apply txt-label-s-regular;
  font-style: oblique;
  text-transform: uppercase;
}

.boothHeaderMeta div::before {
  position: relative;
  content: '';
  float: left;
  margin-right: calc(var(--spacing) * 1.25);
  background-repeat: no-repeat;
  background-position: left top;
}
</style>
